import { Button, HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { SFTrashIcon } from '@assets/icons';
import StyledModal from '@components/general/modals/styled-modal.component';

export default function DeactivateTemplateModal({ disclosure, onConfirm }) {
  return (
    <StyledModal
      disclosure={disclosure}
      title={
        <HStack alignItems='center'>
          <Icon
            as={SFTrashIcon}
            color='brandPrimary.onPrimary'
            boxSize='24px'
          />
          <Text fontSize='md'>Delete Template Permanently?</Text>
        </HStack>
      }
      modalProps={{ scrollBehavior: 'inside' }}
      modalContentProps={{ w: '540px' }}
      modalBodyProps={{ p: '25' }}
      modalHeaderProps={{
        bgColor: 'brandPrimary.primary',
        color: 'brandPrimary.onPrimary'
      }}
      modalCloseButtonProps={{ color: 'brandPrimary.onPrimary' }}
    >
      <Stack>
        <Text>
          If you delete this template, you will no longer be able to access it or apply it to any
          meeting. However, meetings where the template has already been applied will remain
          unaffected.
        </Text>
        <HStack
          justifyContent='flex-end'
          mt={5}
        >
          <Button
            variant='reskinSecondary'
            onClick={disclosure.onClose}
          >
            Cancel
          </Button>
          <Button
            type='submit'
            variant='reskinOutline'
            colorScheme='critical'
            onClick={onConfirm}
          >
            Delete Permanently
          </Button>
        </HStack>
      </Stack>
    </StyledModal>
  );
}
